import { FormattedMessage } from 'react-intl';

import styles from './PlansBenefits.module.scss';

const PlansBenefits = () => (
  <div className={styles.bg}>
    <div className={styles.grid}>
      <div className={styles.item}>
        <img src="/images/new-order/benefits-icons/privacy.svg" width="16" height="16" alt="" />
        <span>
          <FormattedMessage
            id="plansScreen.benefits.privacy"
            defaultMessage="Top-level privacy protection"
            description="Item in product's benefit list"
          />
        </span>
      </div>

      <div className={styles.item}>
        <img src="/images/new-order/benefits-icons/security.svg" width="16" height="16" alt="" />
        <span>
          <FormattedMessage
            id="plansScreen.benefits.noLogs"
            defaultMessage="Strict no-log policy"
            description="Item in product's benefit list"
          />
        </span>
      </div>

      <div className={styles.item}>
        <img src="/images/new-order/benefits-icons/devices.svg" width="16" height="16" alt="" />
        <span>
          <FormattedMessage
            id="plansScreen.benefits.multipleDevices"
            defaultMessage="Up to 6 devices per account"
            description="Item in product's benefit list"
          />
        </span>
      </div>

      <div className={styles.item}>
        <img src="/images/new-order/benefits-icons/country_picker.svg" width="16" height="16" alt="" />
        <span>
          <FormattedMessage
            id="plansScreen.benefits.geoChange"
            defaultMessage="Geolocation change in a tap"
            description="Item in product's benefit list"
          />
        </span>
      </div>

      <div className={styles.item}>
        <img src="/images/new-order/benefits-icons/social.svg" width="16" height="16" alt="" />
        <span>
          <FormattedMessage
            id="plansScreen.benefits.support"
            defaultMessage="24/7 customer support"
            description="Item in product's benefit list"
          />
        </span>
      </div>

      <div className={styles.item}>
        <img src="/images/new-order/benefits-icons/video.svg" width="16" height="16" alt="" />
        <span>
          <FormattedMessage
            id="plansScreen.benefits.streaming"
            defaultMessage="Unlimited streaming"
            description="Item in product's benefit list"
          />
        </span>
      </div>
    </div>
  </div>
);

export default PlansBenefits;
